import React, { useContext, useEffect, useState } from "react";
import {
  Alert,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { Btn, H3 } from "../../AbstractElements";
import { Cancel, Save, Selectdefault } from "../../Shared/Constants";
import { useForm } from "react-hook-form";
import UserContext from "./ContextProvider";
import InputError from "../../Shared/Components/Form/InputError";
import { getRolesApi } from "./Api/GetRoles";
import { togleLoading } from "../../Shared/Utils/alertLoading";

export default function UserForm() {
  const [togglePassword, setTogglePassword] = useState(false);
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  //context
  const { saving, createItem, apiErrors, modalTogle, modal, item, updateItem } =
    useContext(UserContext);
  //form
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm();

  const onSubmit = (data) => {
    if (item && item?.id) {
      updateItem(data, item?.id);
    } else {
      createItem(data);
    }
  };
  useEffect(() => {
    reset({
      first_name: item?.first_name,
      last_name: item?.last_name,
      password: item?.password,
      role_id:
        item?.roles && item?.roles.length > 0 ? item?.roles[0].id : undefined,
    });

    if (item?.permissions) {
      setPermissions(item.permissions);

      item?.permissions.forEach((element) => {
        setValue(`permissions.[${element.name}]`, true);
      });
    }
  }, [item]);

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  const fetchRoles = async () => {
    let response = await getRolesApi();

    if (response.result === "success") {
      setRoles(response.data.items);
    }
  };
  useEffect(() => {
    setValue("role_id", item?.role_id);
  }, [roles]);

  useEffect(() => {
    fetchRoles();
  }, []);
  useEffect(() => {
    togleLoading(saving);
  }, [saving]);

  return (
    <Form onSubmit={handleSubmit(onSubmit)} id="userForm">
      <Modal isOpen={modal} toggle={modalTogle} className="rounded-1" size="md">
        <ModalHeader toggle={modalTogle}>
          <div>
            <H3
              attrH3={{
                className: "modal-title",
                id: "exampleModalLabel1",
              }}
            >
              {item?.id ? "Modificar Usuario" : "Agregar Usuario"}
            </H3>
          </div>
        </ModalHeader>
        <ModalBody>
          <Alert
            className="alert-dismissible"
            color="danger inverse"
            isOpen={alertOpen}
            toggle={ToggleAlert}
          >
            <i class="icon-alert"></i>
            {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
          </Alert>

          <Form className="form-bookmark">
            <Row>
              <Col md="12">
                <div className="row g-2">
                  <FormGroup className="mb-3 col-md-12">
                    <Label htmlFor="first_name" className="form-label">
                      Nombre
                    </Label>
                    <input
                      name="first_name"
                      id="first_name"
                      className={`form-control ${
                        errors.first_name && "is-invalid"
                      }`}
                      type="text"
                      {...register("first_name", {
                        required: "El nombre es obligatorio",
                      })}
                      placeholder="Ingresa el nombre del usuario"
                      autoComplete="off"
                    />

                    <InputError errors={errors} name="first_name" />
                  </FormGroup>
                  <FormGroup className="mb-3 col-md-12">
                    <Label htmlFor="last_name" className="form-label">
                      Apellido
                    </Label>
                    <input
                      name="last_name"
                      className={`form-control ${
                        errors.last_name && "is-invalid"
                      }`}
                      type="text"
                      {...register("last_name", {
                        required: "El apellido es obligatorio",
                      })}
                      placeholder="Ingresa el apellido del usuario"
                      autoComplete="off"
                    />
                    <InputError errors={errors} name="last_name" />
                  </FormGroup>

                  <FormGroup>
                    <Label
                      htmlFor="exampleFormControlSelect4"
                      className="form-label"
                    >
                      ROL
                    </Label>
                    <select
                      id="exampleFormControlSelect4"
                      className={`form-select ${
                        errors.role_id && "is-invalid"
                      }`}
                      name="role_id"
                      {...register("role_id", {
                        required: "El rol es obligatorio",
                      })}
                    >
                      <option value={""}>{Selectdefault}</option>
                      {roles.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                    <InputError errors={errors} name="role_id" />
                  </FormGroup>
                  {!item?.id ? (
                    <FormGroup className="mb-3 col-md-12">
                      <Label htmlFor="email" className="form-label">
                        Email
                      </Label>
                      <input
                        className="form-control"
                        type="text"
                        {...register("email", {
                          required: "El email es obligatorio",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, // Regular expression for email format
                            message: "Por ravor ingresa un email valido", // Custom message for invalid format
                          },
                        })}
                        placeholder="email@ejemplo.com"
                        autoComplete="off"
                        value={item?.email}
                      />
                      <InputError errors={errors} name="email" title="Email" />
                    </FormGroup>
                  ) : (
                    ""
                  )}

                  <FormGroup className="mb-3 col-md-12">
                    <Label htmlFor="password" className="form-label">
                      Password
                    </Label>
                    <input
                      className="form-control"
                      type={togglePassword ? "text" : "password"}
                      {...register("password", {
                        required: item?.id
                          ? false
                          : "El password es obligatorio",
                      })}
                      placeholder="Ingresa un password"
                      autoComplete="off"
                    />

                    <div
                      className="show-hide"
                      onClick={() => setTogglePassword(!togglePassword)}
                    >
                      <span className={togglePassword ? "" : "show"}></span>
                    </div>
                    <InputError errors={errors} name="password" />
                  </FormGroup>
                </div>
              </Col>
            </Row>
            {/* Botones */}
            <Btn
              attrBtn={{
                color: "secondary",
                className: "ms-1",
                onClick: modalTogle,
              }}
            >
              {Cancel}
            </Btn>
            <Btn
              attrBtn={{
                type: "submit",
                form: "userForm",

                className: "ms-1",
                color: `${isDirty ? "primary" : "secondary"}`,
                disabled: !isDirty,
              }}
            >
              {Save}
            </Btn>
          </Form>
        </ModalBody>
      </Modal>
    </Form>
  );
}
